import script from "./SafcoInputData.vue?vue&type=script&setup=true&lang=js"
export * from "./SafcoInputData.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__